<template>
    <div>
        <el-row class="searchSection">
            <el-button v-if="Acs('/customer-cooperator/create')" type="primary" size="mini" @click="showAddDialog()">添加协作人</el-button>
        </el-row>
        <el-row>
            <el-table :data="list" v-loading="loading">
                <el-table-column prop="user_name" label="协作人"></el-table-column>
                <el-table-column prop="created_at" label="绑定时间"></el-table-column>
                <el-table-column prop="memo" label="备注"></el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button v-if="Acs('/customer-cooperator/delete') || scope.row.user_id == $store.getters.userId" @click="showDeleteDialog(scope.row)" type="text" size="small">解除协作</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-row>

        <el-dialog title="添加客户协作人" :visible.sync="dialogFormVisible">
            <el-form ref="form" :model="form" label-width="100px" :rules="rules">
                <el-form-item label="协作人：" prop="user_id">
                    <UserSelect ref="user" v-model="form.user_id" @change="userHandleChange($event)"></UserSelect>
                </el-form-item>
                <el-form-item label="备注：">
                    <el-input type="textarea" v-model="form.memo" autocomplete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitForm('form')" :loading="loading">确 定</el-button>
            </div>
        </el-dialog>
    </div>
  </template>
  <style scoped>
  
  </style>
  <script>
  import CustomerCooperator from "~/services/CustomerCooperator";
  import UserSelect from "~/widgets/UserSelect.vue";
  export default {
    name: "cooperator",
  
    components: {
        UserSelect
    },
  
    props: {
        customer_id:{
            type: Number,
            required: true
        }
    },
  
    data() {
        return {
            loading: false,
            list: [],
            dialogFormVisible: false,
            form: {
                user_id: '',
                user_name: '',
                customer_id: this.customer_id,
                memo: '',
            },
            rules: {
                user_id: [
                    {required: true, message: '请选择协作人', trigger: 'change'},
                ],
            } 
        };
    },
  
    mounted() {},
  
    created: function () {
        this.getList();
    },
  
    methods: {
        //获取列表
        getList() {
            // loading 动画
            this.loading = true;
            CustomerCooperator.getList({customer_id: this.customer_id}).then((res) => {
                if (res.code == 0) {
                    this.list = res.data;
                }
                this.loading = false;
            }).catch((err) => {
                console.error(err);
                this.loading = false;
            });
        },

        //业务员姓名远程搜索组件赋值
        userHandleChange(object) {
            this.form.user_id = object.label;
            this.form.user_name = object.value;
        },

        showAddDialog(){
            this.form = {
                user_id: '',
                user_name: '',
                customer_id: this.customer_id,
                memo: '',
            };
            if(this.$refs['user']){
                this.$refs['user'].reset();
            }
            this.dialogFormVisible = true;
        },

        //删除客户的提示和数据处理。
        showDeleteDialog(obj) {
            this.$confirm("确定要解除协作人吗？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
                center: true
            }).then(() => {
                this.handleDelete(obj.id);
            })
        },

        //删除客户
        handleDelete(id) {
            CustomerCooperator.delete(id).then(res => {
                if(res && res.code == 0){
                    this.$message({
                        message: '删除成功',
                        type: 'success'
                    });
                    this.getList();
                }else{
                    this.$message({
                        message: res.msg,
                        type: 'error'
                    });
                }
                this.submitSearch();
            }).catch((err) => {
                console.error(err);
            });
        },

        /**@description 提交处理 */
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.loading = true;
                    let quote;
                    if(this.form.id > 0){
                        quote = CustomerCooperator.update(this.form);
                    }else{
                        quote = CustomerCooperator.create(this.form);
                    }
                    quote.then(res => {
                        if (res && res.code == 0) {
                            this.$message({
                                message: '操作成功',
                                type: 'success'
                            });
                            this.getList();
                            this.dialogFormVisible = false;
                        }
                        this.loading = false;
                    }).catch(err => {
                        console.error(err);
                        this.$message({
                            message: res.msg,
                            type: 'error'
                        });
                        this.loading = false;
                    });
                } else {
                    console.log('error submit!!');
                }
            });
        },
    },
  };
  </script>


// WEBPACK FOOTER //
// src/views/customer/cooperator.vue